/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreatePromotionRequestSchedule } from './CreatePromotionRequestSchedule';
import {
    CreatePromotionRequestScheduleFromJSON,
    CreatePromotionRequestScheduleFromJSONTyped,
    CreatePromotionRequestScheduleToJSON,
    CreatePromotionRequestScheduleToJSONTyped,
} from './CreatePromotionRequestSchedule';

/**
 * 
 * @export
 * @interface CreatePromotionRequest
 */
export interface CreatePromotionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionRequest
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionRequest
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePromotionRequest
     */
    pointsExpense?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionRequest
     */
    discountType: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePromotionRequest
     */
    discountAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromotionRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromotionRequest
     */
    allowRepeat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromotionRequest
     */
    accumulated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromotionRequest
     */
    availableInShop: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionRequest
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePromotionRequest
     */
    maxRedemptions?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePromotionRequest
     */
    minExpense?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof CreatePromotionRequest
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreatePromotionRequest
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionRequest
     */
    internalDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromotionRequest
     */
    showPopup: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromotionRequest
     */
    availableInPos: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromotionRequest
     */
    availableInAdmin: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreatePromotionRequest
     */
    pickupType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePromotionRequest
     */
    freeDelivery: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreatePromotionRequest
     */
    timesPerPerson?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePromotionRequest
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePromotionRequest
     */
    products?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePromotionRequest
     */
    locations?: Array<string>;
    /**
     * 
     * @type {CreatePromotionRequestSchedule}
     * @memberof CreatePromotionRequest
     */
    schedule?: CreatePromotionRequestSchedule;
}

/**
 * Check if a given object implements the CreatePromotionRequest interface.
 */
export function instanceOfCreatePromotionRequest(value: object): value is CreatePromotionRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('availableInShop' in value) || value['availableInShop'] === undefined) return false;
    if (!('showPopup' in value) || value['showPopup'] === undefined) return false;
    if (!('availableInPos' in value) || value['availableInPos'] === undefined) return false;
    if (!('availableInAdmin' in value) || value['availableInAdmin'] === undefined) return false;
    if (!('freeDelivery' in value) || value['freeDelivery'] === undefined) return false;
    return true;
}

export function CreatePromotionRequestFromJSON(json: any): CreatePromotionRequest {
    return CreatePromotionRequestFromJSONTyped(json, false);
}

export function CreatePromotionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePromotionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'pointsExpense': json['pointsExpense'] == null ? undefined : json['pointsExpense'],
        'discountType': json['discountType'],
        'discountAmount': json['discountAmount'] == null ? undefined : json['discountAmount'],
        'enabled': json['enabled'],
        'allowRepeat': json['allowRepeat'] == null ? undefined : json['allowRepeat'],
        'accumulated': json['accumulated'] == null ? undefined : json['accumulated'],
        'availableInShop': json['availableInShop'],
        'code': json['code'] == null ? undefined : json['code'],
        'maxRedemptions': json['maxRedemptions'] == null ? undefined : json['maxRedemptions'],
        'minExpense': json['minExpense'] == null ? undefined : json['minExpense'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'internalDescription': json['internalDescription'] == null ? undefined : json['internalDescription'],
        'showPopup': json['showPopup'],
        'availableInPos': json['availableInPos'],
        'availableInAdmin': json['availableInAdmin'],
        'pickupType': json['pickupType'] == null ? undefined : json['pickupType'],
        'freeDelivery': json['freeDelivery'],
        'timesPerPerson': json['timesPerPerson'] == null ? undefined : json['timesPerPerson'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'products': json['products'] == null ? undefined : json['products'],
        'locations': json['locations'] == null ? undefined : json['locations'],
        'schedule': json['schedule'] == null ? undefined : CreatePromotionRequestScheduleFromJSON(json['schedule']),
    };
}

export function CreatePromotionRequestToJSON(json: any): CreatePromotionRequest {
    return CreatePromotionRequestToJSONTyped(json, false);
}

export function CreatePromotionRequestToJSONTyped(value?: CreatePromotionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'name': value['name'],
        'description': value['description'],
        'pointsExpense': value['pointsExpense'],
        'discountType': value['discountType'],
        'discountAmount': value['discountAmount'],
        'enabled': value['enabled'],
        'allowRepeat': value['allowRepeat'],
        'accumulated': value['accumulated'],
        'availableInShop': value['availableInShop'],
        'code': value['code'],
        'maxRedemptions': value['maxRedemptions'],
        'minExpense': value['minExpense'],
        'startTime': value['startTime'] == null ? undefined : ((value['startTime']).toISOString()),
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
        'internalDescription': value['internalDescription'],
        'showPopup': value['showPopup'],
        'availableInPos': value['availableInPos'],
        'availableInAdmin': value['availableInAdmin'],
        'pickupType': value['pickupType'],
        'freeDelivery': value['freeDelivery'],
        'timesPerPerson': value['timesPerPerson'],
        'categories': value['categories'],
        'products': value['products'],
        'locations': value['locations'],
        'schedule': CreatePromotionRequestScheduleToJSON(value['schedule']),
    };
}

